export default __webpack_public_path__ + "static/media/linkedin.89004aa0.svg";